// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".register-terms .el-dialog__header{display:none}.register-terms .el-dialog__body{padding:0}", ""]);
// Exports
module.exports = exports;
